import "@babel/polyfill";
import './Polyfill';
import DataStore from './DataStore';
import Utils from '../common/Utils';
import CharChange from './components/CharChange';
import {cnbConfig} from './CnbConfigKor';
import IScrollTab from "../common/components/IScrollTab";
//import Footer from './components/Footer'; // 공통푸터 사용으로 인한 주석 처리
// import NcoinGift from "./components/NcoinGift";
/**
 * bns.common
 * @category bns.common
 * @memberof module:bns.common
 * @param  {Object} _config={} 설정 옵션
 * @param  {Object} _config.apiDomain="" api Domain
 */
class App {
	constructor(_config = {}) {
		this.store = new DataStore(_config);

		//new Footer(this.store, '#footer'); // 공통푸터 사용으로 인한 주석 처리
		new CharChange(this.store, '#nc-cnb .ncc-character-panel .ncc-character-list-wrap .ncc-character-list');
		// window.ncoinGiftPopup = new NcoinGift(_config);
		
		if (_config.cnbActive) {
			cnbConfig.active = _config.cnbActive;
		}

		window.cnb && window.cnb.start( cnbConfig );
	}
}

Utils.namespace('nc.bns.common');
nc.bns.common = App;

Utils.namespace('nc.bns.common.tabMenu');
nc.bns.common.tabMenu = IScrollTab;

Utils.namespace('nc.bns.utils');
nc.bns.utils = Utils;
